// src/Styles/CategoryFormStyles.ts
import { SxProps, Theme } from '@mui/material/styles';
import { COLORS } from '../../theme/themeConstants';

export const categoryStyles = {
  ListContainer: {
    p: 2,
    border: '1px solid #e0e0e0',
    marginTop: '20px',
    color: '#666',
  },
  paperStyle: {
    p: 2,
    borderRadius: 3,
    backgroundColor: 'background.paper',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    px: 5,
  },
  formContainer: {
    p: 4,
    // backgroundColor: '#f5f5f5',
  } as SxProps<Theme>,

  formGrid: {
    padding: 10,
  } as SxProps<Theme>,

  labelBox: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: { xs: 'flex-start', sm: 'center' },
    gap: { xs: 2, sm: 6 },
  } as SxProps<Theme>,

  labelText: {
    minWidth: { xs: '100%', sm: '250px' },
    mb: '2.5%',
  } as SxProps<Theme>,

  inputField: {
    backgroundColor: 'white',
    px: 1,
    width: '100%',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    borderRadius: '4px',
    '&:before': {
      borderBottom: 'none',
    },
    '&:after': {
      borderBottom: 'none',
    },
    '&:hover:not(.Mui-disabled):before': {
      borderBottom: 'none',
    },
    '& input::placeholder': {
      fontSize: '12px',
      opacity: 0.7,
    },
  } as SxProps<Theme>,

  fileInfoText: {
    fontSize: '12px',
    color: 'text.secondary',
  } as SxProps<Theme>,

  loaderBox: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    bgcolor: 'rgba(255, 255, 255, 0.6)',
    backdropFilter: 'blur(3px)',
    zIndex: 1200,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 'inherit',
  } as SxProps<Theme>,

  errorText: {
    fontSize: '12px',
    mt: 1,
    marginLeft: 0,
  } as SxProps<Theme>,

  buttonsWrapper: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    alignItems: { xs: 'flex-start', sm: 'center' },
    gap: { xs: 2, sm: 6 },
  } as SxProps<Theme>,

  saveButton: {
    color: '#fff',
    textTransform: 'none',
    px: 4,
    boxShadow: 1,
    borderRadius: 0,
    '&:hover': {
      backgroundColor: 'none',
    },
    // '&:hover': {
    //   backgroundColor: '#e6520e',
    // },
  } as SxProps<Theme>,

  cancelButton: {
    backgroundColor: '#ed6d03',
    color: '#fff',
    textTransform: 'none',
    px: 4,
    boxShadow: 1,
    borderRadius: 0,
    '&:hover': {
      backgroundColor: '#ed6d03',
    },
  } as SxProps<Theme>,

  manageCuisineTitle: {
    backgroundColor: '#f5f5f5',
    py: 1,
    px: 2,
    fontSize: '20px',
    color: '#555',
    fontFamily: 'inherit',
    border: '1px solid',
    borderColor: '#d1cfcf',
  } as SxProps<Theme>,

  addButton: {
    fontSize: '13px',
    textTransform: 'none',
    fontFamily: 'inherit',
    py: '2px',
    px: '10px',
    minHeight: '32px',
    backgroundColor: '#fff',
    color: '#000',
    boxShadow: 2,
    marginBottom: '0px',
    '&:hover': {
      backgroundColor: '#f5f5f5',
      boxShadow: 3,
    },
  } as SxProps<Theme>,

  cellStyle: {
    borderRight: '1px solid #e0e0e0',
    fontSize: '13px',
  } as SxProps<Theme>,

  emptyCell: {
    borderRight: '1px solid #e0e0e0',
    fontSize: '13px',
    padding: 0,
  } as SxProps<Theme>,

  tableCell: {
    borderRight: '1px solid #e0e0e0',
    fontSize: '13px',
    display: 'flex',
    justifyContent: 'center',
    padding: 0,
  } as SxProps<Theme>,

  tableHeader: {
    borderRight: '1px solid #e0e0e0',
    fontSize: '15px',
    padding: 0,
    color: COLORS.text.primary,
    fontWeight: 'bold',
  } as SxProps<Theme>,

  errorCard: {
    px: 2,
    py: 3,
    mt: 2,
    borderRadius: 2,
    backgroundColor: '#fff',
  } as SxProps<Theme>,
};
